import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=6b7a799b"
import script from "./CatalogList.vue?vue&type=script&setup=true&lang=js"
export * from "./CatalogList.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports